import { Checkbox, Chip, styled, Table, TableCell, TableRow } from '@mui/material';
import { getJobsColorPalette } from 'dashboard409a/hooks/useJobsColorPalette';
import { JOBS_EVENT_COLORS } from 'dashboard409a/pages/Workboard/common/constants';
import { ValuationStatus } from 'dashboard409a/pages/Workboard/common/types';

const getStatusColor = (status?: string) => {
  if (!status) {
    return JOBS_EVENT_COLORS.DEFAULT;
  }

  // Convert ValuationStatus enum value to palette key
  const statusKey = Object.keys(ValuationStatus).find(
    key => ValuationStatus[key as keyof typeof ValuationStatus] === status
  ) as keyof ReturnType<typeof getJobsColorPalette> | undefined;

  if (!statusKey) {
    return JOBS_EVENT_COLORS.DEFAULT;
  }

  const palette = getJobsColorPalette();
  return palette[statusKey] || JOBS_EVENT_COLORS.DEFAULT;
};

const RootContainer = styled('div')(() => ({
  width: '100%',
}));

const StyledTable = styled(Table)(() => ({
  minWidth: 750,
}));

const StyledCheckbox = styled(Checkbox)(() => ({}));

const StyledTableRow = styled(TableRow)(() => ({
  height: '33px',
  cursor: 'pointer',
}));

const StyledTableCell = styled(TableCell)(() => ({
  padding: '6px',
  fontSize: '14px',
}));

const StyledTableCellEmptyMessage = styled(TableCell)(({ theme }) => ({
  textAlign: 'center',
  padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
  fontSize: '16px',
  color: theme.palette.primary.main,
}));

interface StatusChipProps {
  status?: string;
}

const StyledStatusChip = styled(Chip)<StatusChipProps>(({ theme, status }) => ({
  backgroundColor: getStatusColor(status),
  color: theme.palette.common.black,
  borderRadius: '10px',
  padding: `0px ${theme.spacing(1.5)}`,
  fontSize: '14px',
}));

const StyledSpanEmptyStatus = styled('span')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.common.black,
}));

export {
  RootContainer,
  StyledTable,
  StyledCheckbox,
  StyledTableRow,
  StyledTableCell,
  StyledTableCellEmptyMessage,
  StyledStatusChip,
  StyledSpanEmptyStatus,
};
